export const TIMEZONES = {
  INDIA: "Asia/Kolkata",
  UTC: "UTC",
};

/**
 *
 * @param {string | Date} date - Date time object or the date string that needs to be converted
 * @param {string} convertTo - Which timezone to convert the date to
 * @param {string} mode - Different date resolution modes for extending this method in the future as we needed a hack to handle this currently
 */
export function dateConverter(date, convertTo, mode) {
  // always has to be a datetime object
  let dateToConvert = new Date(date);

  // current logic is going to be straight forward. We are directly going to return the date after stripping the time part from it right now. In future
  const dateResolver = {
    default: function () {
      return dateToConvert.toISOString().split("T")[0];
    },
    convertToUTC: function () {
      return "";
    },
    convertToIST: function () {
      return dateToConvert.toLocaleDateString("en-CA", { timezone: "Asia/Kolkata" }).split(",")[0]
    },
  };

  return dateResolver[mode]();
}
